import { Controller } from "@hotwired/stimulus"

// Opens a command palette dialog with ⌘K / Ctrl+K.
// Targets:
//   - dialog (the <dialog> element)
//   - input (search input)
//   - list (results <ul>)
export default class extends Controller {
  static targets = ["dialog", "input", "list"]

  connect() {
    this._handler = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "k") {
        e.preventDefault()
        this.open()
      } else if (e.key === "Escape" && this.hasDialogTarget && this.dialogTarget.open) {
        this.close()
      }
    }
    document.addEventListener("keydown", this._handler)
  }

  disconnect() {
    document.removeEventListener("keydown", this._handler)
  }

  open() {
    if (!this.hasDialogTarget) return
    this.dialogTarget.showModal()
    this.inputTarget?.focus()
  }

  close() {
    if (!this.hasDialogTarget) return
    this.dialogTarget.close()
    if (this.hasInputTarget) {
      this.inputTarget.value = ""
      this.filter()
    }
  }

  filter() {
    if (!this.hasListTarget || !this.hasInputTarget) return
    const q = this.inputTarget.value.toLowerCase().trim()
    this.listTarget.querySelectorAll("li").forEach(li => {
      const label = li.textContent.toLowerCase()
      li.style.display = !q || label.includes(q) ? "" : "none"
    })
  }

  navigate(event) {
    const href = event.currentTarget?.dataset?.href
    if (href) {
      this.close()
      if (window.Turbo?.visit) {
        window.Turbo.visit(href)
      } else {
        window.location.href = href
      }
    }
  }
}
